import router from '@/router';
import { defineStore } from 'pinia';
import type { LocationQueryRaw } from 'vue-router';

interface RouteQueryState {
  query: LocationQueryRaw;
}

export const useRouteQueryStore = defineStore('routeQueryStore', {
  state: (): RouteQueryState => ({
    query: {},
  }),
  getters: {},
  actions: {
    async patch(query: LocationQueryRaw) {
      Object.entries(query).forEach(([key, value]) => {
        if (value === undefined) {
          delete this.query[key];
        } else {
          this.query[key] = value;
        }
      });
      await router.replace({ query: this.query });
    },
    async replace(query: LocationQueryRaw) {
      this.query = { ...query };
      await router.replace({ query: this.query });
    },
  },
});
